(function(){
  // 你要匹配的插件标签（改成实际的组件名，例如 'moast-product-carousel'）
  const TARGET_TAG = 'moast-carousel';
  console.log("moast inited");
  // 你要注入的 CSS 内容
  const CSS_TEXT = `
    .slide {
      display: grid !important;
      grid-template: 1fr / 1fr !important;
    }
    .slide > * {
      grid-area: 1 / 1 !important;
    }
    .caption {
      align-self: end !important;
      justify-self: center !important;
      font-size: 12px !important;
      line-height: 1.2 !important;
      text-align: center !important;
      padding: 8px 12px !important;
      background: rgba(0,0,0,.5) !important;
      color: #fff !important;
      display: block !important;
      border-radius: 20px !important;
      z-index: 1 !important;
      margin: 6px !important;
    }
  `;

  // 监听 DOM 变化
  const observer = new MutationObserver(() => {
    document.querySelectorAll(TARGET_TAG).forEach(el => {
      if (!el.shadowRoot || el.__styleInjected) return; // 只注入一次

      try {
        const sheet = new CSSStyleSheet();
        sheet.replaceSync(CSS_TEXT);
        el.shadowRoot.adoptedStyleSheets = [
          ...(el.shadowRoot.adoptedStyleSheets || []),
          sheet
        ];
        el.__styleInjected = true; // 防止重复注入
        console.log(`[BFCM] style injected into <${TARGET_TAG}>`);
      } catch (err) {
        // 如果浏览器不支持 adoptedStyleSheets，就 fallback 用 <style>
        const style = document.createElement('style');
        style.textContent = CSS_TEXT;
        el.shadowRoot.appendChild(style);
        el.__styleInjected = true;
        console.log(`[BFCM] fallback style appended into <${TARGET_TAG}>`);
      }
    });
  });

  observer.observe(document.body, { childList: true, subtree: true });

  // 可选：初始化时也扫描一次
  document.addEventListener('DOMContentLoaded', () => observer.takeRecords());
})();
